import { useState, useCallback } from 'react';
import * as communeManagementAction from "../redux/store/commune-management/commune.store";

export const useLookupCommune = () => {
    const [commune, setCommune] = useState([]);

    const getLookupCommune = useCallback(async (districtId) => {
        if (!districtId) {
            setCommune([]);
            return [];
        }
        try {
            const res = await communeManagementAction.GetLookupCommune(districtId);
            if (res && res.content) {
                setCommune(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return { commune, setCommune, getLookupCommune };
};
